<h1 *ngIf="device.deviceId !== currentDeviceBeingEdited; else editingDeviceName">{{
  device.name ?? device.deviceId }}</h1>
<ng-template #editingDeviceName>
  <input type="text" class="cardFleet__content--input" value="{{device.name ?? device.deviceId}}"
    (keyup.enter)="onEditDeviceName($event)" (blur)="onEditDeviceName($event)" (click)="onStopPropagation($event)" />
</ng-template>
<img src="../../../../assets/images/legends/note-pencil.svg" alt="icon edit device name on device list"
  [class.edit-icon--active]="device.deviceId === currentDeviceBeingEdited" (click)="onEditDeviceName($event)" />